import { render, staticRenderFns } from "./ImsUserTable.vue?vue&type=template&id=740ae2f8&scoped=true&"
import script from "./ImsUserTable.vue?vue&type=script&lang=js&"
export * from "./ImsUserTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740ae2f8",
  null
  
)

export default component.exports